export default {
  STORAGE_PROVIDER: {
    type: 'enum',
    values: [
      'LOCAL_STORAGE',
      'DEXIE',
    ],
    default: 'DEXIE',
  },
};
